<template>
  <div class="app"  v-bind:style="{ backgroundColor: '' }">
    <!-- change pass inputs -->
    <b-modal hide-footer="" ref="modal" title="Change password"
      id="changePasswordForm" >
      <changePassword :modalRef=$refs.modal :key="counter"/>
    </b-modal>
    <AppHeader fixed>
      <SidebarToggler class="d-lg-none" display="md" mobile />
      <SidebarToggler class="d-md-down-none" display="lg" />
      
      <!-- logo PC-->
      <b-navbar-nav class="ml-auto d-md-down-none">
        <b-nav-item>
          <img src="img/brand/TechnoTeams48.png" class=""/>
          <!-- Hajj Management -->
        </b-nav-item>
      </b-navbar-nav>
      <!-- logo mobile -->
      <b-navbar-nav class="d-lg-none" display="md" mobile>
        <b-nav-item>
          <img src="img/brand/TechnoTeams48.png" class=""/>
        </b-nav-item>
      </b-navbar-nav>

      <b-navbar-nav class="ml-auto">
      <!-- change pass & logout btn -->
        <b-nav-item class="pr-5">
          <b-button size="" variant="warning" @click="passChangeClicked"
            b-v-modal.changePasswordForm>
            Change password
          </b-button>
        </b-nav-item>
        <!-- logout btn -->
        <b-nav-item class="pr-3">
          <b-button variant="dark" @click="onLogout">Logout</b-button>
        </b-nav-item>
      </b-navbar-nav>
      <!-- <b-modal size="" hide-footer="" ref="modal" title="Change password"
            id="changePasswordForm" >
            <changePassword :key="counter"/>
      </b-modal> -->
    </AppHeader>
    <div class="app-body">
      <AppSidebar fixed>
        <SidebarHeader/>
        <SidebarForm/>
        <SidebarNav :navItems="nav"></SidebarNav>
        <SidebarFooter/>
        <SidebarMinimizer/>
      </AppSidebar>
      <main class="main">
        <!-- <Breadcrumb fixed :list="list" class="m-0 p-1" /> -->
        <div id='body' class="animated fadeIn" >
          <router-view></router-view>
        </div>
      </main>
    </div>
    <!--footer-->
    <TheFooter id='non-printable' fixed style="height:25px;">
      <div  class="ml-auto pb-1">
        <a href="https://TechnoTeams.com" target="_blank">Developed by TechnoTeams</a>
        <span class="ml-1">&copy; 2019</span>
      </div>
      <!-- <div class="ml-auto">
        <span class="mr-1">Powered by CoreUI for Vue</span>
      </div> -->
    </TheFooter>
  </div>
</template>

<script>
import axios from 'axios'
import VueNotifications from 'vue-notifications'

import nav from '@/_nav'
import { Header as AppHeader, SidebarToggler, Sidebar as AppSidebar, SidebarFooter, SidebarForm, SidebarHeader, SidebarMinimizer, SidebarNav, Aside as AppAside, AsideToggler, Footer as TheFooter, Breadcrumb } from '@coreui/vue'
//import DefaultAside from './DefaultAside'
import DefaultHeaderDropdownAccnt from './DefaultHeaderDropdownAccnt'
import changePassword from './changePassword'
export default {
  name: 'full',
  components: {
    changePassword,
    //AsideToggler,
    AppHeader,
    AppSidebar,
    //AppAside,
    TheFooter,
    Breadcrumb,
    //DefaultAside,
    DefaultHeaderDropdownAccnt,
    SidebarForm,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer
  },
  data () {
    return {
      nav: nav.items,
      counter:0,
      year:""
    }
  },
  computed: {
    name () {
      return this.$route.name
    },
    list () {
      return this.$route.matched.filter((route) => route.name || route.meta.label )
    }
  },
  methods: {
    passChangeClicked(evt) {
      // console.log(evt);
       this.$refs.modal.show();
       this.counter+=1;
    },
    onLogout(evt){
      // axios.get("http://192.168.100.107:8080/pilgrimDB/logout.php?user='admin'",  {withCredentials: true})
      axios.get( "pilgrimDB/logout.php?user='admin'",  {withCredentials: true})
      .then(response=>{
        // console.log(response)
        if(response.data==1){
          this.showSuccessMsg({title:"logged out", timeout:1500, position:"topCenter"})
          this.$router.push({name:'login'})
        }
        else{
          this.showErrorMsg({title:response.data, timeout:3000})
          this.$router.push({name:'login'})
        }
      })
      .catch(error=>{
        if(!error.response){
          this.showErrorMsg({title:"Network Error!!"})
        }
        else{
          this.showErrorMsg({title:error.response})
        }
        console.log(error)
      })
    }
  },
  notifications: {
      showSuccessMsg: {
        type: VueNotifications.types.success,
        title: '',
        message: '',
        position: "topRight",
        timeout: 5000
      },
      showInfoMsg: {
        type: VueNotifications.types.info,
        title: '',
        message: '',
        position: "topRight",
        timeout: 5000

      },
      showWarnMsg: {
        type: VueNotifications.types.warn,
        title: '',
        message: '',
        position: "topRight",
        timeout: 10000

      },
      showErrorMsg: {
        type: VueNotifications.types.error,
        title: '',
        message: '',
        position: "topRight",
        timeout: 10000
      }
  }
}
</script>
